import { Link } from "react-router-dom";
import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

// Assets
import boy from "../assets/Images/boy.png";
import grocery from "../assets/Images/grocery.png";
import card from "../assets/Images/card.png";
import groww from "../assets/Images/groww.png";
import leafy from "../assets/Images/leafy.jpeg";
import fruits from "../assets/Images/fruits.jpg";
import idli from "../assets/Images/idli.jpeg";
import milk from "../assets/Images/milk.jpeg";
import offer from "../assets/Images/offer.jpeg";
import fresh from "../assets/Images/fresh.jpeg";

const Home = () => {
  const categories = [
    { title: "Fresh Vegetables", itemCount: "24 items", image: fresh },
    { title: "Leafy Vegetables", itemCount: "16 items", image: leafy },
    { title: "Offer Items", itemCount: "32 items", image: grocery },
    { title: "Fresh Fruits", itemCount: "12 items", image: fruits },
    { title: "Idli & Dosa Batter", itemCount: "24 items", image: idli },
    { title: "Milk And Dairy", itemCount: "16 items", image: milk },
    { title: "Grocery Items", itemCount: "32 items", image: offer },
  ];

  return (
    <>
      <Navbar />
      <div className="min-h-screen w-full">
        <div className="max-w-[1920px] mx-auto px-6 2xl:px-16">
          {/* Hero Section */}
          <div className="bg-[#da2127] rounded-2xl my-8 p-12 2xl:p-16 relative overflow-hidden min-h-[600px] 2xl:min-h-[800px]">
            <div className="flex flex-col md:flex-row gap-60 items-center justify-between max-w-[1600px] mx-auto pt-12">
              <div className="md:w-1/2 space-y-8">
                <h1 className="text-5xl 2xl:text-6xl font-bold text-white leading-tight">
                  Make healthy<br />
                  life with <span className="text-[#CDFF67]">fresh</span><br />
                  grocery
                </h1>
                <p className="text-gray-100 text-lg 2xl:text-xl max-w-md">
                  Get the best quality and most delicious grocery food in the world,
                  you can get them all use our website.
                </p>
                <button className="bg-[#FF6B47] hover:bg-[#FF5A33] text-white px-8 py-3.5 rounded-xl font-semibold text-lg">
                  <Link to="/product" state={{ categories }}>Shop Now</Link>
                </button>
              </div>
              <div className="md:w-1/2 relative xsm:bottom-20 xl:bottom-0">
                <img src={boy} alt="Delivery person" className="w-[500px] h-auto" />
              </div>
            </div>
          </div>
{/* Categories Section */}
<div className="my-16 2xl:my-24 max-w-[1600px] mx-auto px-4">
  <h2 className="text-3xl 2xl:text-4xl font-bold mb-8 text-gray-800 text-center">
    Top Categories
  </h2>

  <div className="overflow-x-auto scrollbar-hide">
    <div className="flex space-x-4 md:space-x-8 w-max">
      {categories.map((category, index) => (
        <Link
          to="/sku"
          state={{ category: category.title }}
          key={index}
          className="flex-shrink-0 w-[calc(100vw/2.5)] sm:w-48 bg-white p-4 md:p-6 2xl:p-8 rounded-lg shadow-sm hover:shadow-md transition-shadow no-underline text-current"
        >
          <div className="flex flex-col items-center">
            <div className="w-24 h-24 md:w-32 md:h-32 rounded-lg overflow-hidden mb-4">
              <img
                src={category.image}
                alt={category.title}
                className="w-full h-full object-cover"
              />
            </div>
            <h3 className="text-gray-800 font-medium mb-1 text-center text-base md:text-lg">
              {category.title}
            </h3>
            <p className="text-gray-400 text-sm text-center">{category.itemCount}</p>
          </div>
        </Link>
      ))}
    </div>
  </div>
</div>


          {/* Showcase Section */}
          <div className="bg-[#da2127] rounded-2xl my-16 2xl:my-24 p-12 2xl:p-16">
            <div className="flex flex-col md:flex-row items-center justify-between gap-12 2xl:gap-16 max-w-[1600px] mx-auto">
              <div className="md:w-1/2 flex justify-center relative">
                <div className="absolute inset-0 bg-gradient-to-br from-transparent to-gray-50/50 rounded-lg" />
                <img src={grocery} alt="Fresh vegetables" className="rounded-lg w-[400px] h-auto relative z-10" />
              </div>
              <div className="md:w-1/2 space-y-8">
                <div>
                  <p className="text-white font-bold text-2xl tracking-wide mb-4">What We Offer</p>
                  <h2 className="text-3xl font-bold text-white leading-tight mb-4">
                    Fresh, high-quality groceries—delivered <br />
                    with care.
                  </h2>
                  <p className="text-white text-2xl">
                    We prioritize quality in each of our grocery,<br />
                    below are the advantages of our products.
                  </p>
                </div>
                <ul className="space-y-3">
                  {[
                    "Exceptional Service That Stands Out",
                    "Handled by Experienced Professionals",
                    "Easy Online Ordering Experience",
                  ].map((item, index) => (
                    <li key={index} className="flex items-center gap-3">
                      <div className="w-2 h-2 2xl:w-3 2xl:h-3 rounded-full bg-white" />
                      <span className="text-white text-xl">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* Features Section */}
          <div className="bg-gray-100 rounded-2xl my-16 2xl:my-24 p-12 2xl:p-16">
            <div className="flex flex-col md:flex-row items-center gap-12 2xl:gap-16 max-w-[1600px] mx-auto">
              <div className="md:w-1/2 space-y-6">
                <h2 className="text-2xl 2xl:text-3xl font-bold">
                  What makes our service the smart choice?
                </h2>
                <div className="space-y-4">
                  <div className="flex items-center bg-white rounded-lg p-4 2xl:p-6 shadow-sm">
                    <span className="text-gray-700">We provide the fastest service</span>
                  </div>
                  <div className="flex items-center bg-white rounded-lg p-4 2xl:p-6 shadow-sm">
                    <span className="text-gray-700">Fast and reliable delivery</span>
                  </div>
                </div>
              </div>
              <div className="md:w-1/2 relative">
                <div className="bg-[#da2127] rounded-lg p-4">
                  <img src={card} alt="Service feature" className="rounded-lg w-full max-w-[250px] h-auto" />
                </div>
                <img
                  src={groww}
                  alt="Additional feature"
                  className="hidden md:block rounded-lg w-full max-w-[180px] absolute right-40 top-16"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Home;
